export const countries = () => 'FNOLSifarnici/GetDrzave';
export const citizenship = () => 'FNOLSifarnici/GetDrzaveZaDrzavljanstva';
export const cities = () => 'FNOLSifarnici/GetNaselja';
export const activePoliciesList = () => 'FNOLDomacinstvo/GetListaAktivnihPolisa';
export const claimSubmit = () => 'FNOLDomacinstvo/OnlinePrijavaStete';
export const publicUtilities = () => 'FNOLSifarnici/GetJavnaKomunalnaPreduzeca';
export const unions = () => 'FNOLSifarnici/GetSindikate';
export const policyDetails = () => 'FNOLDomacinstvo/GetDetaljiPolise';
export const claimConfirmation = () => 'FNOL/PotvrdaPrijaveStete';
export const claimConfirmationAnonymous = () => 'FNOL/PotvrdaPrijaveSteteAnonimni';
export const addDocuments = () => 'FNOL/UploadDokumentacije';
export const documents = (id: string) => `FNOL/GetDokumentaZaUpload?stetaTempId=${id}`;
export const insuranceMethod = () => 'FNOLSifarnici/GetDomacinstvoNacineOsiguranja';
export const damageTypes = () => 'FNOLSifarnici/GetDomacinstvoVrstaOstecenja';
export const userData = () => 'FNOL/GetPodaciOUlogovanomKorisniku';
export const personRoles = () => 'FNOLSifarnici/GetDomacinstvoSvojstvaUcesnika';
export const objectType = () => 'FNOLSifarnici/GetDomacinstvoVrstaObjekata';
export const causes = (insuranceMethod: number, policyNumber: string, publicUtility: number) =>
    `FNOLSifarnici/GetDomacinstvoUzrokeStete?nacinOsigID=${insuranceMethod}&brPolisePotvrde=${policyNumber}&jkpID=${publicUtility}`;
export const oneTimePassword = () => 'FNOL/GenerisiPrivremenuLozinku';
export const floorDamageTypes = () => 'FNOLSifarnici/GetDomacinstvoVrstaOstecenjaPoda';
export const floorTypes = () => 'FNOLSifarnici/GetDomacinstvoVrstaPoda';
export const roomTypes = () => 'FNOLSifarnici/GetDomacinstvoVrstaProstorije';
export const personValidation = () => 'FNOL/ValidacijaLica';
export const streetNames = (id: string) => `FNOLSifarnici/GetAdrese?maticniBrojNaselja=${id}`;
export const wallFinishTyes = () => 'FNOLSifarnici/GetDomacinstvoVrstaObradeZidova';
export const insuredPerson = () => 'FNOLDomacinstvo/GetOsiguranikZaPolisu';
export const getContactData = (ucn: string) => `FNOL/GetKontaktPodaci?jmbg=${ucn}`;
export const checkContactData = (tempId: string) => `FNOL/GetPotrebnaVerifikacijaKontakata?stetaTempId=${tempId}`;
